import React, { useState, useRef, FunctionComponent, useEffect } from "react";
import styles from "./CreateWhatsapptemplate.module.css";
import TextInput from "../../Components/TextInput/TextInput";
import { FaUser } from "react-icons/fa";
import Dropdown from "../../Components/DropDown/Dropdown";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import { AiOutlineClose } from "react-icons/ai";
import { useLocation } from "react-router-dom";
import { themeColors } from "../../Components/theme";
import Label from "../../Components/Label";
import WhatsAppEditor from "../../Components/WhatsappEditor/WhatsappEditor";
import { getDispositionList, getSubDispositionList } from "../../Values/utils";
import { createWhatsappTemplate, editWhatsappTemplate, fetchDropdownValues } from "../../Services/marketingAutomation";
import DropdownWithValue from "../../Components/DropDown/DropdownWithValue";
import { Tooltip } from "@mui/material";
import { FaInfoCircle } from "react-icons/fa";
import InputModal from "../../Components/Modals/InputModal/InputModal";
import { IoMdArrowRoundBack } from "react-icons/io";
import { showSnackbarAction } from "../../Redux/actions";
import WhatsappPreview from "../../Components/WhatsappPreview/WhatsappPreview";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type props = {
  user: any;
  history: any;
  organization: any;
  organizationId: string;
  organizationUsers: any[];
  branchList: any[];
  theme: any;
  authToken: any;
  constants: any;
  hasActiveWAPackage: boolean;
};

const CreateWhatsappTemplate: FunctionComponent<props> = ({
  user,
  history,
  organization,
  organizationId,
  organizationUsers,
  branchList,
  theme,
  authToken,
  constants,
  hasActiveWAPackage
}) => {
  const location: any = useLocation();
  const templateNameRef: any = useRef();
  const templateDisplayNameRef: any = useRef();

  const [load, setLoad] = useState(false);
  const dispatcher = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const [isTemplateAdmin, setIsTemplateAdmin]: any = useState(null);
  // Only one preview open at a time
  const [expandedPreview, setExpandedPreview] = useState<null | 'sampleValues' | 'examples'>('sampleValues');
  // const [category, setCategory] = useState<{ value: string; label: string }>({value:"",label:""});
  // const [disposition, setDisposition] = useState<{ value: string; label: string }>({value:"",label:""});
  // const [subDisposition, setSubDisposition] = useState<{ value: string; label: string }>({value:"",label:""});
  // const [templateScope, setTemplateScope] = useState<{ value: string; label: string }>({value:"",label:""});
  // const [selectedWabaIds, setSelectedWabaIds] = useState<any>([]);
  // const [selectedWabaNumbers, setSelectedWabaNumbers] = useState<any>([]);
  const [wabaIds, setWabaIds] = useState([]);
  const [wabaNumbers, setWabaNumbers] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [step, setStep] = useState(1); // step control
  const [id, setId] = useState("");
  const [dispositionList,setDispositionList] = useState([]);
  const [subDispositionList, setSubDispositionList] = useState([]);
  const [showAddSubDispositionModal, setShowAddSubDispositionModal] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);

  useEffect(() => {
    if (user && user.adminTemplateRole === true) {
      setIsTemplateAdmin(true);
    }else{
      setIsTemplateAdmin(false);
    }
  }, [user])

  useEffect(() => {
    if (hasActiveWAPackage === null || hasActiveWAPackage === undefined || user === null || user === undefined) {
      return;
    }

    const isAllowedAccess = Boolean(hasActiveWAPackage) || Boolean(user?.adminTemplateRole);
    // const isAllowedAccess = Boolean(user?.adminTemplateRole);
    if (!isAllowedAccess) {
      history.push("/");
    }
  }, [hasActiveWAPackage, user, history]);

  const [formData, setFormData]: any = useState({
    templateName: "",
    templateDisplayName: "",
    template_category: {value: "", label:""},
    template_type: {value: "", label:""},
    templateScope: {value:"", label:""},
    disposition: {value:"", label:""},
    subDisposition: {value:"", label:""},
    components: {
      body: { text: "" },
      footer: { text: "" }
    },
    examples: [],
    sampleValues: [],
    selectedWabaIds: [],
    selectedWabaNumbers: []
    // scope: ""
  });

  useEffect(()=>{
    if(isTemplateAdmin === false){
      updateFormField("template_category",  {value: "Marketing", label:"Marketing"});
      updateFormField("template_type",  {value: "Broadcast Messages", label:"Broadcast Messages"});
      updateFormField("disposition",  {value: "My Templates", label:"My Templates"})
    }
  },[isTemplateAdmin])

  useEffect(() => {
    if (location.state?.data) {
      // console.log("location.state?.data",location.state?.data)
      if(location.state?.isViewOnly){
        setIsViewOnly(true);
      }
      const data = location.state.data;
      const scope = data.globalType === "All" ? "All" : "Specific";
      const templateType = data.template_type === "Promotional" ? "Broadcast Messages" : "System Triggered Messages";
      setFormData({
        templateName: data.template_name || "",
        templateDisplayName: data.template_Display_Name || "",
        template_category: { value: data.template_category, label: data.template_category },
        template_type: { value: templateType, label: templateType },
        templateScope: { value: scope, label: scope },
        disposition: { value: data.disposition, label: data.disposition },
        subDisposition:  { value: data.subDisposition, label: data.subDisposition },
        components: {
          body: { text: data.body || "" },
          footer: { text: data.footer || "" },
        },
        examples: data.sampleValue || [],
        sampleValues: data.placeHolderValue || [],
        selectedWabaIds: data.wabaDropDown ? data.wabaDropDown : [],
        selectedWabaNumbers: data.vNumberDropDown ? data.vNumberDropDown : []
      });
      
      // setCategory({ value: categoryString, label: categoryString });
      // setDisposition({ value: data.disposition, label: data.disposition });
      // setSubDisposition({ value: data.subDisposition, label: data.subDisposition });
      // setTemplateScope({ value: scope, label: scope })
      // setSelectedWabaIds(data.wabaDropDown ? data.wabaDropDown : []);
      // setSelectedWabaNumbers(data.vNumberDropDown ? data.vNumberDropDown : []);
      setId(data._id);
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }

    fetchDropdownValues("WABA_ID", setWabaIds,{});
  }, [location.state]);

  useEffect(()=>{
    if(formData.selectedWabaIds.length > 0){
      let wabaIds = formData.selectedWabaIds
        .map((item: any) => item.label)
        .filter(Boolean)
        .join(","); 
      fetchDropdownValues("WABA_NUMBERS", setWabaNumbers, {wabaIds});
    }else{
      setWabaNumbers([]);
    }
  },[formData.selectedWabaIds])

  useEffect(() => {
    if(formData.template_type.value){
      fetchDropdownValues("DISPOSITION", setDispositionList, {templateType: formData.template_type.value === "Broadcast Messages" ? "Broadcast" : "System"});
    }
  }, [formData.template_type.value])

  useEffect(() => {
    if(formData.disposition.value){
      fetchDropdownValues("SUB_DISPOSITION", setSubDispositionList, {disposition: formData.disposition.value});
    }
  }, [formData.disposition.value])

  const extractPlaceholders = (bodyText: any) => {
    const regex = /{{(\d+)}}/g;
    const matches = [...bodyText.matchAll(regex)];
    return matches.map((m) => m[1]); // ["1","2","3"]
  };

  // 🔹 Helper for nested updates
  const updateFormField = (path: string, value: any) => {
    setFormData((prev: any) => {
      const updated = { ...prev };
      const keys = path.split(".");
      let obj: any = updated;
      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
      }
      obj[keys[keys.length - 1]] = value;
      return updated;
    });
  };

  const buildPayload = () => {
    let globalType =
      formData.templateScope.value === "All"
        ? "All"
        : formData.selectedWabaNumbers.length > 0
          ? "oidSpecific"
          : "wabaIdSpecific";

    // Collect OIDs from selected WABA Numbers (each value = "SOID1,SOID2,...")
    let globalSpecificOids = formData.selectedWabaNumbers.length > 0
      ? formData.selectedWabaNumbers
        .flatMap((item: any) => item.value.split(",")) // split string into array
        .map((oid: string) => oid.trim())                 // clean spaces
        .filter(Boolean)                        // remove empty
      : [];

    // Collect OIDs from selected WABA IDs (each value = "SOID1,SOID2,...")
    let wabaId =
      formData.selectedWabaIds.length > 0
          ? formData.selectedWabaIds
            .flatMap((item: any) => item.label.split(",")) // value contains SOIDs
            .map((wabaId: string) => wabaId.trim())
            .filter(Boolean)
          : [];

    return {
      template_name: formData.templateName.trim(),
      template_category: formData.template_category.value.trim(),
      template_type: formData.template_type.value === "Broadcast Messages" ? "Promotional" : "Transactional",
      // footer: formData.components.footer.text,
      body: formData.components.body.text,
      variable_count: formData.examples.length,
      sampleValue: formData.examples,
      placeHolderValue: formData.sampleValues,
      template_Display_Name: formData.templateDisplayName.trim(),
      disposition: formData.disposition.value.trim(),
      subDisposition: formData.subDisposition.value.trim(),
      globalType: globalType,
      globalSpecificOids: globalSpecificOids,
      wabaId: wabaId
    };
  };

  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const selectInputContainerStyles = { width: "100%", marginRight: "5px" };

  const validateAndNext = () => {
    if (isTemplateAdmin) {
      if (!formData.templateName || !formData.templateName.trim()) {
        dispatcher(showSnackbarAction("Template Name is required", "error"));
        return;
      }
      if (!formData.templateDisplayName || !formData.templateDisplayName.trim()) {
        dispatcher(showSnackbarAction("Template Display Name is required", "error"));
        return;
      }
      if (!formData.template_category.value) {
        dispatcher(showSnackbarAction("Template Category is required", "error"));
        return;
      }
      if (!formData.template_type.value) {
        dispatcher(showSnackbarAction("Template Type is required", "error"));
        return;
      }
      if (!formData.templateScope.value) {
        dispatcher(showSnackbarAction("Template Scope is required", "error"));
        return;
      }
      if (formData.templateScope.value === "Specific" && formData.selectedWabaIds.length < 1) {
        dispatcher(showSnackbarAction("Please select some WABA IDs", "error"));
        return;
      }
    } else {
      if (!formData.templateName || !formData.templateName.trim()) {
        dispatcher(showSnackbarAction("Template Name is required", "error"));
        return;
      }
      if (!formData.templateDisplayName || !formData.templateDisplayName.trim()) {
        dispatcher(showSnackbarAction("Template Display Name is required", "error"));
        return;
      }
      if (!formData.template_category.value) {
        dispatcher(showSnackbarAction("Template Category is required", "error"));
        return;
      }
      if (!formData.template_type.value) {
        dispatcher(showSnackbarAction("Template Type is required", "error"));
        return;
      }
    }
    const payload = buildPayload();
    isEdit ?
      editWhatsappTemplate({ ...payload, Id: id, step: 1 }, dispatcher, history, setStep)
      :
      createWhatsappTemplate({ ...payload, step: 1 }, dispatcher, history, setStep)
  }

  const hasEmptyValue = (arr: string[]) => {
    return arr.some(val => val === null || val === undefined || val.toString().trim() === "");
  }
  // 🔹 Submit Handler
  const handleSubmit = async (status: string) => {
    // e.preventDefault();
    if (!formData.disposition.value) {
      formData.template_type.value === "Broadcast Messages" ?
      dispatcher(showSnackbarAction("Category is required", "error")):
      dispatcher(showSnackbarAction("Disposition is required", "error"));
      return;
    }
    if (!formData.subDisposition.value) {
      formData.template_type.value === "Broadcast Messages" ?
      dispatcher(showSnackbarAction("Sub Category is required", "error")):
      dispatcher(showSnackbarAction("Sub Disposition is required", "error"));
      return;
    }
    if (!formData.components.body.text) {
      dispatcher(showSnackbarAction("Please fill the template body", "error"));
      return;
    }
    const bodyText = formData.components.body.text.trim();
    if (/^\{\{\d+\}\}\s*$/g.test(bodyText.split(" ")[0])) {
      dispatcher(
        showSnackbarAction(
          "Template body cannot start with a variable placeholder",
          "error"
        )
      );
      return;
    }

    if (/\{\{\d+\}\}$/g.test(bodyText) && bodyText.match(/\S+$/)?.[0].startsWith("{{")) {
      dispatcher(
        showSnackbarAction(
          "Template body cannot end with a variable placeholder",
          "error"
        )
      );
      return;
    }
    if ((extractPlaceholders(formData.components.body.text).length != formData.examples.length) || hasEmptyValue(formData.examples)) {
      dispatcher(showSnackbarAction("Please fill all field values", "error"));
      return;
    }
    if ((extractPlaceholders(formData.components.body.text).length != formData.sampleValues.length) || hasEmptyValue(formData.sampleValues)) {
      dispatcher(showSnackbarAction("Please fill all field values", "error"));
      return;
    }
    const payload = buildPayload();
    isEdit ?
      editWhatsappTemplate({ ...payload, status, Id: id }, dispatcher, history)
      :
      createWhatsappTemplate({ ...payload, status }, dispatcher, history)
  };

  const onCloseAddSubDisposition = () => {
    setShowAddSubDispositionModal(false)
    updateFormField("subDisposition", { value: "", label: "" });
  }

  const onSubmitAddSubDisposition = (value: string) => {
    if (!value || !value.trim()) {
      dispatcher(showSnackbarAction("Please enter a value", "error"));
      return;
    }
    setShowAddSubDispositionModal(false);
    updateFormField("subDisposition", { value: value, label: value });
  }

  const preparePreview = (bodyText: string, placeholderArr: string[]) => {
    let preview = bodyText.replace(/\{\{(\d+)\}\}/g, (match, index) => {
      const placeholderIndex = parseInt(index, 10) - 1;
      return placeholderArr[placeholderIndex] ?? match;
    });
    return preview;
  };

  return (
    <>
      <div className={styles.parent} style={containerStyles}>
        {load && <Loading />}
        <div className="d-flex flex-row w-100 px-4 pt-4">
          <h5>{isEdit ? "Edit Template" : "Create Template"}</h5>
          <AiOutlineClose
            className={styles.closeIcon}
            size={25}
            onClick={() => history.replace("/whatsapptemplates")}
          />
        </div>
        {
          step === 2 && (
            <div className="px-4 mt-2" style={{ cursor: "pointer" }} onClick={() => {
              setStep(1);
            }}>
              <IoMdArrowRoundBack size={25} />
            </div>
          )
        }

        <div className="w-100 d-flex flex-column gap-2 px-4">
          <div
            className="card p-4 shadow rounded mt-2"
            style={cardContainerStyles}
          >
            {/* ---------------- STEP 1 ---------------- */}
            {step === 1 && (
              <>
                <div className={styles.box3}>
                  <div className={styles.divide}>
                    <Label label="Template Name" required={true} />
                    <div className={styles.inputContainer}>
                      <TextInput
                        title={""}
                        style={{ backgroundColor: "#fff" }}
                        // ref={templateNameRef}
                        type="text"
                        value={formData.templateName}
                        onChange={(e: any) =>
                          updateFormField("templateName", e.target.value)
                        }
                        disabled={isViewOnly}
                      >
                        <FaUser color={"#808080"} />
                      </TextInput>
                    </div>
                  </div>

                  <div className={styles.divide}>
                    <Label label="Display Name" required={true} />
                    <div className={styles.inputContainer}>
                      <TextInput
                        title={""}
                        style={{ backgroundColor: "#fff" }}
                        // ref={templateDisplayNameRef}
                        type="text"
                        value={formData.templateDisplayName}
                        onChange={(e: any) =>
                          updateFormField("templateDisplayName", e.target.value)
                        }
                        disabled={isViewOnly}
                      >
                        <FaUser color={"#808080"} />
                      </TextInput>
                    </div>
                  </div>

                  {isTemplateAdmin && (
                    <div className={styles.divide}>
                      <Label label="Template Category" required={true} />
                      <div style={{ ...selectInputContainerStyles }}>
                        <Dropdown
                          option={["Marketing", "Utility"]}
                          selectedValue={formData.template_category}
                          setSelectedValue={(value) => {
                            // setCategory(value);
                            updateFormField("template_category", value)
                          }
                          }
                          disable={isViewOnly}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className={styles.box3}>
                  {isTemplateAdmin && (
                    <div className={styles.divide}>
                      <Label label="Template Type" required={true} />
                      <div style={{ ...selectInputContainerStyles }}>
                        <Dropdown
                          option={["Broadcast Messages", "System Triggered Messages"]}
                          selectedValue={formData.template_type}
                          setSelectedValue={(value) => {
                            // setCategory(value);
                            updateFormField("template_type", value)
                          }
                          }
                          disable={isViewOnly}
                        />
                      </div>
                    </div>
                  )}
                  {isTemplateAdmin && (
                    <div className={styles.divide}>
                      <Label label="Template Scope" required={true} />
                      <div style={{ ...selectInputContainerStyles }}>
                        <Dropdown
                          option={["All", "Specific"]}
                          selectedValue={formData.templateScope}
                          setSelectedValue={(value) => {
                            // setTemplateScope(value);
                            updateFormField("templateScope", value)
                          }
                          }
                          disable={isViewOnly}
                        />
                      </div>
                    </div>
                  )}
                  {(formData.templateScope.value == "Specific" && isTemplateAdmin) && (
                    <div className={styles.divide}>
                      <Label label="WABA IDs" required={true} />
                      <div style={{ ...selectInputContainerStyles }}>
                        <DropdownWithValue
                          isMulti
                          option={wabaIds}
                          selectedValue={formData.selectedWabaIds}
                          classNameModifier={styles.dropdown_scroll}
                          setSelectedValue={(value) => {
                            // setSelectedWabaIds(value);
                            updateFormField("selectedWabaIds", value)
                          }
                          }
                          disable={isViewOnly}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className={styles.box3}>
                  {(formData.templateScope.value == "Specific" && isTemplateAdmin) && (
                    <div className={styles.divide}>
                      <Label label="WABA Numbers" required={false} />
                      <div style={{ ...selectInputContainerStyles }}>
                        <DropdownWithValue
                          isMulti
                          option={wabaNumbers}
                          selectedValue={formData.selectedWabaNumbers}
                          classNameModifier={styles.dropdown_scroll}
                          setSelectedValue={(value) => {
                            // setSelectedWabaNumbers(value);
                            updateFormField("selectedWabaNumbers", value)
                          }
                          }
                          disable={isViewOnly}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="mt-4 d-flex justify-content-center">
                  <button
                    type="button"
                    className={styles.button}
                    onClick={() => validateAndNext()}
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {/* ---------------- STEP 2 ---------------- */}
            {step === 2 && (
              <div className="d-flex flex-column gap-3">
                {/* <div>
                  <Label label="Header Type" required={false} />
                  <Dropdown
                    option={["None", "Text", "Media"]}
                    selectedValue={formData.components.header.type}
                    setSelectedValue={(value) =>
                      updateFormField("components.header.type", value)
                    }
                  />

                  {formData.components.header.type.value === "Text" && (
                    <TextInput
                      title=""
                      style={{ backgroundColor: "#fff", marginTop: "8px" }}
                      type="text"
                      // placeholder="Enter header text"
                      value={formData.components.header.text}
                      onChange={(e: any) =>
                        updateFormField("components.header.text", e.target.value)
                      }
                    />
                  )}

                  {formData.components.header.type.value === "Media" && (
                    <div style={{ marginTop: "8px" }}>
                      <Label label="Select Media Type" required={true} />
                      <Dropdown
                        option={["Image", "Video", "Document"]}
                        selectedValue={formData.components.header.mediaType}
                        setSelectedValue={(value) =>
                          updateFormField("components.header.mediaType", value)
                        }
                      />
                    </div>
                  )}
                </div> */}

                <div className={styles.box3}>
                  <div className={styles.divide}>
                    <Label label={formData.template_type.value === "Broadcast Messages" ? "Category" : "Disposition"} required={true} />
                    <div style={{ ...selectInputContainerStyles }}>
                      <Dropdown
                        option={dispositionList.length > 0 ? dispositionList.map((item: any) => item.value) : []}
                        selectedValue={formData.disposition}
                        setSelectedValue={(value) => {
                          // setDisposition(value)
                          updateFormField("disposition", value)
                        }
                        }
                        disable={isViewOnly || isTemplateAdmin === false}
                      />
                    </div>
                  </div>
                  {!isTemplateAdmin?
                    <div className={styles.divide}>
                      <Label label={formData.template_type.value === "Broadcast Messages" ? "Sub Category" : "Sub Disposition"} required={true} />
                      <div className={styles.inputContainer}>
                        <TextInput
                          title={""}
                          style={{ backgroundColor: "#fff" }}
                          // ref={templateNameRef}
                          type="text"
                          value={formData.subDisposition.value}
                          onChange={(e: any) =>
                            updateFormField("subDisposition", {label: e.target.value, value: e.target.value})
                          }
                          disabled={isViewOnly}
                        >
                          <FaUser color={"#808080"} />
                        </TextInput>
                      </div>
                    </div> :
                    <div className={styles.divide}>
                      <Label label={formData.template_type.value === "Broadcast Messages" ? "Sub Category" : "Sub Disposition"} required={true} />
                      <div style={{ ...selectInputContainerStyles }}>
                        {
                          formData.template_type.value === "Broadcast Messages" ?
                            <Dropdown
                              option={subDispositionList.length > 0 ? subDispositionList.map((item: any) => item.value) : []}
                              selectedValue={formData.subDisposition}
                              setSelectedValue={(value) => {
                                // setSubDisposition(value)
                                updateFormField("subDisposition", value)
                              }
                              }
                              title="+ Add new"
                              setDetails={() => { setShowAddSubDispositionModal(true) }}
                              disable={isViewOnly}
                            />
                            :
                            <Dropdown
                              option={subDispositionList.length > 0 ? subDispositionList.map((item: any) => item.value) : []}
                              selectedValue={formData.subDisposition}
                              setSelectedValue={(value) => {
                                // setSubDisposition(value)
                                updateFormField("subDisposition", value)
                              }
                              }
                              // title="+ Add new"
                              // setDetails={() => { setShowAddSubDispositionModal(true) }}
                              disable={isViewOnly}
                            />
                        }
                      </div>
                    </div>
                  }

                  <div className={styles.divide}>
                  </div>
                </div>

                {/* Body */}
                <div>
                  <Label label="Body Text" required={true} />
                  <WhatsAppEditor
                    value={formData.components.body.text}
                    onChange={(val) => updateFormField("components.body.text", val)}
                    maxLength={1024}
                    disabled={isViewOnly}
                  />
                </div>
                <div className={styles.exampleBlks}>
                  {/* Examples */}
                  <div className={styles.exampleBlk}>
                    {
                      extractPlaceholders(formData.components.body.text).length > 0 && (
                        <div className={styles.exampleBlkItem}>
                          <div style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // border: "2px solid black",
                            gap: "8px" // adds spacing between label and tooltip
                          }}>
                            <Label label="Field Values" required={true} />

                            {/* <Tooltip title="Enter a sample value that represents the variable you added. For example, if the variable is a customer name, you can enter Shankar." arrow>
                              <span style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                                <FaInfoCircle />
                              </span>
                            </Tooltip> */}
                          </div>

                          <p style={{ fontSize: "0.65rem", marginTop: "-0.5rem" }}>
                            Examples for Field values: First Name, Project Name, Company Name, Project Highlights, Tag Line, Experience, Payment Details etc…
                          </p>

                          {extractPlaceholders(formData.components.body.text).map((ph, idx) => (
                            <div className={styles.exampleBlkItemRow}>
                              <p className={styles.exampleBlkItemRowLabel}>
                                Field {idx + 1}
                              </p>
                              <TextInput
                                key={idx + 1}
                                title={""}
                                style={{ backgroundColor: "#fff", marginBottom: "8px" }}
                                type="text"
                                // placeholder={`Example for {{${ph}}}`}
                                value={formData.sampleValues[idx] || ""}
                                onChange={(e) => {
                                  let newSampleValues: string[] = [...formData.sampleValues];
                                  newSampleValues[idx] = e.target.value;
                                  setFormData((prev: any) => ({ ...prev, sampleValues: newSampleValues }));
                                }}
                                disabled={isViewOnly}
                              />
                            </div>
                          ))}
                        </div>
                      )
                    }

                    {extractPlaceholders(formData.components.body.text).length > 0 && (
                      <Accordion sx={{height:"fit-content"}} expanded={expandedPreview === 'sampleValues'} onChange={() => setExpandedPreview(expandedPreview === 'sampleValues' ? null : 'sampleValues')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="whatsapp-preview-content"
                          id="whatsapp-preview-header"
                        >
                          Whatsapp Preview
                        </AccordionSummary>
                        <AccordionDetails>
                          <WhatsappPreview
                            previewContent={preparePreview(formData.components.body.text, formData.sampleValues)}
                          />
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </div>

                  {/* Excel Column Names */}
                  <div className={styles.exampleBlk}>
                    {
                      // extractPlaceholders(formData.components.body.text).length > 0 && (
                      formData.sampleValues.length > 0 && (
                        <div className={styles.exampleBlkItem}>
                          <div style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        // border: "2px solid black",
                        gap: "8px" // adds spacing between label and tooltip
                      }}>
                        <Label label="Add Content For Template" required={true} />

                        {/* <Tooltip title="Enter a descriptive label for the sample value. For example, if the sample value is Shankar, enter Customer Name here." arrow>
                          <span style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                            <FaInfoCircle />
                          </span>
                        </Tooltip> */}
                      </div>
                      {/* <p style={{ fontSize: "0.65rem", marginTop: "-0.5rem" }}>
                        Enter an example name for each example
                      </p> */}

                          {/* {extractPlaceholders(formData.components.body.text).map((ph, idx) => ( */}
                          {formData.sampleValues.map((ph: any, idx: any) => (
                            <div className={styles.exampleBlkItemRow}>
                              <p className={styles.exampleBlkItemRowLabel}>
                                {/* Set value for Field {idx + 1} */}
                                   Enter content for {formData.sampleValues[idx]}
                              </p>
                              {/* <p style={{ fontSize: "0.65rem", marginTop: "-0.5rem" }}>
                                Enter content for {formData.sampleValues[idx]}
                              </p> */}
                              <TextInput
                                key={idx + 1}
                                title={""}
                                style={{ backgroundColor: "#fff", marginBottom: "8px" }}
                                type="text"
                                // placeholder={`Example for {{${ph}}}`}
                                value={formData.examples[idx] || ""}
                                onChange={(e) => {
                                  let newExamples: string[] = [...formData.examples];
                                  newExamples[idx] = e.target.value;
                                  setFormData((prev: any) => ({ ...prev, examples: newExamples }));
                                }}
                                disabled={isViewOnly}
                              />
                            </div>
                          ))}
                        </div>
                      )
                    }

                    {formData.sampleValues.length > 0 && (
                      <Accordion sx={{height:"fit-content"}} expanded={expandedPreview === 'examples'} onChange={() => setExpandedPreview(expandedPreview === 'examples' ? null : 'examples')}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="whatsapp-preview-content"
                          id="whatsapp-preview-header"
                        >
                          Whatsapp Preview
                        </AccordionSummary>
                        <AccordionDetails>
                          <WhatsappPreview
                            previewContent={preparePreview(formData.components.body.text, formData.examples)}
                          />
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </div>
                </div>
                {/* Footer */}
                {/* <div>
                  <Label label="Footer Text ( Optional )" required={false} />
                  <TextInput
                    title={""}
                    style={{ backgroundColor: "#fff" }}
                    type="text"
                    // placeholder="Enter footer"
                    value={formData.components.footer.text}
                    onChange={(e: any) =>
                      updateFormField("components.footer.text", e.target.value)
                    }
                  />
                </div> */}

                {/* Buttons */}
                {/* <div>
                  <Label label="Buttons (Optional)" required={false} />

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary mt-2"
                    onClick={() =>
                      setFormData((prev: any) => ({
                        ...prev,
                        components: {
                          ...prev.components,
                          buttons: [
                            ...prev.components.buttons,
                            { type: "QUICK_REPLY", text: "New Button" }, // default
                          ],
                        },
                      }))
                    }
                  >
                    + Add Button
                  </button>

                  <ul className="mt-2 space-y-2">
                    {formData.components.buttons.map((btn: any, idx: number) => (
                      <li key={idx} className="p-2 border rounded">

                        <select
                          value={btn.type}
                          onChange={(e) => {
                            const newBtns = [...formData.components.buttons];
                            newBtns[idx].type = e.target.value;
                            updateFormField("components.buttons", newBtns);
                          }}
                        >
                          <option value="QUICK_REPLY">Quick Reply</option>
                          <option value="URL">Call To Action - URL</option>
                          <option value="PHONE_NUMBER">Call To Action - Phone</option>
                        </select>

                        <input
                          type="text"
                          placeholder="Button Text"
                          value={btn.text || ""}
                          onChange={(e) => {
                            const newBtns = [...formData.components.buttons];
                            newBtns[idx].text = e.target.value;
                            updateFormField("components.buttons", newBtns);
                          }}
                        />

                        {btn.type === "URL" && (
                          <input
                            type="url"
                            placeholder="https://example.com"
                            value={btn.url || ""}
                            onChange={(e) => {
                              const newBtns = [...formData.components.buttons];
                              newBtns[idx].url = e.target.value;
                              updateFormField("components.buttons", newBtns);
                            }}
                          />
                        )}

                        {btn.type === "PHONE_NUMBER" && (
                          <input
                            type="tel"
                            placeholder="+911234567890"
                            value={btn.phone_number || ""}
                            onChange={(e) => {
                              const newBtns = [...formData.components.buttons];
                              newBtns[idx].phone_number = e.target.value;
                              updateFormField("components.buttons", newBtns);
                            }}
                          />
                        )}

                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger ml-2"
                          onClick={() => {
                            const newBtns = [...formData.components.buttons];
                            newBtns.splice(idx, 1);
                            updateFormField("components.buttons", newBtns);
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                </div> */}

                {/* Navigation */}
                {isViewOnly ? <></> :
                  <div className="mt-4 d-flex justify-content-center gap-4">
                    <button onClick={() => {
                      handleSubmit("Draft")
                    }} className={styles.button}>
                      Save As Draft
                    </button>
                    <button onClick={() => {
                      handleSubmit("Submit")
                    }} className={styles.button}>
                      Submit
                    </button>
                  </div>}
              </div>
            )}
          </div>
        </div>
      </div>
      {showAddSubDispositionModal && <InputModal inputTitle="Sub Disposition" inputPlaceholder="Enter sub disposition" close={onCloseAddSubDisposition} onSubmit={onSubmitAddSubDisposition} />}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organization: state.organization,
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    branchList: state.branchList.data,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken,
    constants: state.constants.data,
    user: state.user.data,
    hasActiveWAPackage: state.organization.hasActiveWAPackage,
  };
};

export default connect(mapStateToProps)(CreateWhatsappTemplate);